import React, { useEffect, useState } from "react";
import {
  Button,
  FormGroup,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  Row,
  Col,
  Container,
  Input,
  Label,
  NavLink as TabLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap";
import classnames from "classnames";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css';
import { requestApi } from "../../../request-api";
import { useNavigate, Link } from "react-router-dom";
import { directUrl, homePageUrl } from "../../../helpers/Constants";

//assets
import upload from "../../../assets/image/icons/upload.svg";
import { async } from "q";
import { API_URL } from "../../../config";
import { userStore } from "../../../stores";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Triangle } from "react-loader-spinner";
import { width } from "@mui/system";
import FileSaver from "file-saver";
import xls from "../../../assets/bulkBranchUplod.xlsx";

function CreateBranch() {
  let navigate = useNavigate();

  let [currentActiveTab, setCurrentActiveTab] = useState("1");
  let [calendarValue, setCalenderValue] = useState(new Date());
  let [showCalender, setShowCalender] = useState(false);
  let [selectedDate, setSelectedDate] = useState("");
  let [companyName, setCompanyName] = useState("");
  let [branchPocNumber, setBrachPocNumber] = useState("");
  let [branchId, setBranchId] = useState("");
  let [pocNumber, setPocNumber] = useState("");
  let [complainceOfficer, setComplianceOfficer] = useState("");
  let [emailId, setEmailId] = useState("");
  let [officeAddress, setOfficeAddress] = useState("");
  let [company, setCompany] = useState([]);
  let [compliancer, setCompliancer] = useState([]);
  const [fileData, setFileData] = useState([]);
  let [filetxt, setFiletxt] = useState("Choose File");
  let [browseremove, setBrowseremove] = useState("Browse");
  let [formErrors, setFormErrors] = useState({});
  let [isSubmit, setIsSubmit] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  let [loading, setLoading] = useState(false);
  let [modal, setModal] = useState(false);

  const successToast = (message) =>
    toast.success(message, {
      position: "bottom-right",
    });

  const errorToast = (error) =>
    toast.error(error, {
      position: "bottom-right",
    });

  const onFileChange = (event) => {
    setFileData(event.target.files[0]);
  };

  const toggle = (tab) => {
    if (currentActiveTab !== tab) {
      setCurrentActiveTab(tab);
    }
  };
  useEffect(() => {
    setLoading(true);
    getCompany();
    setLoading(false);
  }, []);
  const getCompany = async () => {
    setLoading(true);
    requestApi("/auditor/company/getCompanyByUserId", {
      method: "get",
    })
      .then((data) => {
        let company = [];
        data.data.map((comp) => {
          company.push(comp.company_name);
        });
        setCompany(company);
        setLoading(false);
      })
      .catch((error) => {
        errorToast(error);
      });

    requestApi("/auditor/getComplianceofficer", {
      method: "get",
    })
      .then((data) => {
        let complianceOfficer = [];
        data.data.map((comp) => {
          complianceOfficer.push(comp.name);
        });
        setCompliancer(complianceOfficer);
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  const customModal = () => {
    console.log("method called", modal);
    setModal(!modal);
  };

  const submitForm = async (e) => {
    setLoading(true);
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", fileData);
    formData.append("filename", fileData.name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: userStore.token || "",
      },
    };
    try {
      const data = await axios.post(
        `${API_URL}/auditor/branch/uploadBranch`,
        formData,
        config
      );
      setLoading(false);
      if (data.data.statusCode === 200) {
        successToast("Successfully created bulk branch");
        navigate(`${directUrl}auditor/branch`);
      }else{
        errorToast(data.data.message)
      }
    } catch (error) {
      setLoading(false);
      errorToast(error.message);
    }
  };

  useEffect(() => {
    setSelectedDate(
      `${calendarValue.getDate()}/${
        calendarValue.getMonth() + 1
      }/${calendarValue.getFullYear()}`
    );
  }, [calendarValue]);

  const formValidation = (values) => {
    setLoading(true);
    console.log(startDate);
    const errors = {};
    const mobRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    const emailRegex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (currentActiveTab === "1") {
      if (companyName == "") {
        errors.companyname = "Company Name is required";
      } else if (companyName == "Select Company") {
        errors.companyname = "Company Name is required";
      }
      if (branchPocNumber == "") {
        errors.branchpocname = "Branch POC Name is required";
      }
      if (branchId == "") {
        errors.branchid = "Branch ID is required";
      }
      if (pocNumber == "") {
        errors.pocnumber = "POC Number is required";
      } else if (!mobRegex.test(pocNumber)) {
        errors.pocnumber = "Invalid Number";
      }
      if (emailId == "") {
        errors.email = "Email Address is required";
      } else if (!emailRegex.test(emailId)) {
        errors.email = "Invalid Email Address";
      }
      if (officeAddress == "") {
        errors.officeadd = "Office Address is required";
      }
      // if (!values.datepicker) {
      //   errors.datepicker = "Date is required";
      // }
      // if (complainceOfficer == '') {
      //   errors.selectofficer = "Select Officer is required";
      // } else if (complainceOfficer == 'Select Complaince Officer') {
      //   errors.selectofficer = "Select Officer is required";
      // }
      setLoading(false);
    }
    if (currentActiveTab === "2") {
      if (fileData.length == 0) {
        errors.file = "File is required";
      } else {
      }
      setLoading(false);
    }

    return errors;
  };

  const createNewBranch = async () => {
    setLoading(true);
    console.debug("sending code", complainceOfficer);
    requestApi("/auditor/branch/createBranch", {
      method: "post",
      body: JSON.stringify({
        company_name: companyName,
        branch_id: branchId,
        branch_poc_name: branchPocNumber,
        date_of_joining: startDate,
        poc_number: pocNumber,
        compliance_officer_id: complainceOfficer,
        email_id: emailId,
        office_address: officeAddress,
      }),
    })
      .then((data) => {
        console.log(data);
        if (data.statusCode === 200) {
          setLoading(false);
          successToast("Successfully created branch");
          navigate(`${directUrl}auditor/branch`);
        }
        if (data.statusCode == 400) {
          setLoading(false);
          errorToast("Branch Id Already Exist");
        }
      })
      .catch((error) => {
        setLoading(false);
        errorToast(error.message);
        console.log(error);
      });
  };

  const file_select = (e) => {
    onFileChange(e);
    if (e.target.files[0] == null) {
      setFiletxt("Choose File");
      setBrowseremove("Browse");
    } else {
      const filepath = e.target.files[0].name;
      setFiletxt(filepath);
      setBrowseremove("Change File");
    }
  };

  const validateBanner = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    const validate = formValidation();
    setFormErrors(validate);
    console.log("validate", validate);
    if (currentActiveTab === "2") {
      errorToast(validate.file);
    }
    if (Object.keys(validate).length == 0) {
      if (currentActiveTab === "1") {
        createNewBranch(e);
      } else {
        submitForm(e);
      }
    }
  };
  return (
    <main onClick={() => setShowCalender(!showCalender)}>
      <section className="lyt-section"></section>
      {loading ? (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      ) : null}

      <section className="lyt-section p-0">
        <Container fluid className="typ-container">
          <div className="breadcrumb-row">
            <Breadcrumb className="bs-breadcrumb mt-0">
              <BreadcrumbItem>
                <Link to={`${directUrl}auditor/branch`}>Branch</Link>
              </BreadcrumbItem>

              <BreadcrumbItem active>Create Branch</BreadcrumbItem>
            </Breadcrumb>
            <button
              className="bs-btn typ-white"
              onClick={() => {
                FileSaver.saveAs(xls, "Sample-Branch.xls");
              }}
            >
              {" "}
              <span class="icon icon-plus"></span> Sample Branch Template{" "}
            </button>
          </div>
          <div className="bs-card">
            <Row>
              <div className="bs-tabs">
                <Nav tabs>
                  <NavItem>
                    <TabLink
                      className={classnames({
                        active: currentActiveTab === "1",
                      })}
                      onClick={() => {
                        toggle("1");
                      }}
                    >
                      Create Branch
                    </TabLink>
                  </NavItem>
                  <NavItem>
                    <TabLink
                      className={classnames({
                        active: currentActiveTab === "2",
                      })}
                      onClick={() => {
                        toggle("2");
                      }}
                    >
                      Upload File
                    </TabLink>
                  </NavItem>
                </Nav>
              </div>
              <TabContent activeTab={currentActiveTab} className="px-0">
                <TabPane tabId="1">
                  <Container fluid>
                    <FormGroup className="bs-form">
                      <Row>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="examplePassword"
                            className="mr-sm-2 cstm-label"
                          >
                            Company Name<span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            className="typ-select mob-margin cstm-input"
                            type="select"
                            name="name"
                            id="exampleSelect"
                            onChange={(e) => {
                              setCompanyName(e.target.value);
                            }}
                          >
                            <option>Select Company</option>
                            {company.map((comp) => {
                              return (
                                <option key={comp} value={comp}>
                                  {comp}
                                </option>
                              );
                            })}
                          </Input>
                          <p className="error-message">
                            {formErrors.companyname}
                          </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="examplePassword"
                            className="mr-sm-2 cstm-label"
                          >
                            Branch POC Name
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            type="text"
                            name="text"
                            id="examplePassword"
                            className="cstm-input"
                            placeholder="Enter POC Name"
                            onChange={(e) => {
                              setBrachPocNumber(e.target.value);
                            }}
                          />
                          <p className="error-message">
                            {formErrors.branchpocname}
                          </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="exampleEmail"
                            className="mr-sm-2 cstm-label"
                          >
                            Branch ID<span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            type="text"
                            name="text"
                            id="exampleEmail"
                            className="cstm-input"
                            placeholder="Enter Branch ID"
                            onChange={(e) => {
                              setBranchId(e.target.value);
                            }}
                          />
                          <p className="error-message">{formErrors.branchid}</p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="examplePassword"
                            className="mr-sm-2 cstm-label"
                          >
                            Date of Joining
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          {/* <div class="searchbox-wrap">
                                                <Input type="text" name="date" id="examplePassword" className='cstm-input' placeholder="Enter Date of Joining" />
                                                <button className='bs-btn typ-date'><span class="icon-calendar"></span></button>
                                            </div> */}
                          {/* {showCalender && <div className='bs-calender'>
                                                <Calendar onChange={setCalenderValue} value={calendarValue} />
                                            </div>} */}
                          <div className="calender-area">
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                              placeholderText="Enter Date of Joining"
                            />
                          </div>
                          <p className="error-message">
                            {formErrors.datepicker}
                          </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="exampleEmail"
                            className="mr-sm-2 cstm-label"
                          >
                            POC Number<span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            type="text"
                            name="text"
                            id="exampleEmail"
                            className="cstm-input"
                            placeholder="Enter POC Number"
                            onChange={(e) => {
                              setPocNumber(e.target.value);
                            }}
                          />
                          <p className="error-message">
                            {formErrors.pocnumber}
                          </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="examplePassword"
                            className="mr-sm-2 cstm-label"
                          >
                            Assign Compliance Officer
                          </Label>
                          <Input
                            className="typ-select mob-margin"
                            type="select"
                            name="select"
                            id="exampleSelect"
                            onChange={(e) => {
                              setComplianceOfficer(e.target.value);
                            }}
                          >
                            <option>Select Compliance Officer</option>
                            {compliancer.map((comp) => {
                              return (
                                <option key={comp} value={comp}>
                                  {comp}
                                </option>
                              );
                            })}
                          </Input>
                          <p className="error-message">
                            {formErrors.selectofficer}
                          </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label
                            for="exampleEmail"
                            className="mr-sm-2 cstm-label"
                          >
                            Email ID<span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            type="email"
                            name="email"
                            className="cstm-input"
                            id="exampleEmail"
                            placeholder="Enter Email ID"
                            onChange={(e) => {
                              setEmailId(e.target.value);
                            }}
                          />
                          <p className="error-message">{formErrors.email}</p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <Label for="exampleText" className="cstm-label">
                            Office Address
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            type="textarea"
                            name="text"
                            className="cstm-input"
                            rows="5"
                            id="exampleText"
                            placeholder="Enter Office Address"
                            onChange={(e) => {
                              setOfficeAddress(e.target.value);
                            }}
                          />
                          <p className="error-message">
                            {formErrors.officeadd}
                          </p>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                          <button
                            className="bs-btn "
                            type="button"
                            onClick={(e) => {
                              validateBanner(e);
                            }}
                          >
                            SUBMIT
                          </button>
                        </Col>
                      </Row>
                    </FormGroup>
                  </Container>
                </TabPane>
                <TabPane tabId="2">
                  <Container>
                    <Row>
                      <div className="selector">
                        <img className="upload_img" src={upload} />
                        <FormGroup className="text-center">
                          <div className="selector-text">
                            <h3 className="dynamic-message">
                              {" "}
                              <span className="browse-files-text">
                                {filetxt}
                              </span>{" "}
                              <span
                                className="bs-btn typ-small btn-submit"
                                type="button"
                              >
                                {browseremove}
                              </span>
                              <input
                                type="file"
                                id="fileinput"
                                className="default-file-input"
                                onChange={file_select}
                              />{" "}
                            </h3>
                            <label className="text-label">
                              {" "}
                              Supported format: Excel{" "}
                            </label>
                          </div>
                          <button
                            className="bs-btn btn-submit"
                            onClick={(e) => validateBanner(e)}
                          >
                            SUBMIT
                          </button>
                        </FormGroup>
                      </div>
                    </Row>
                  </Container>
                </TabPane>
              </TabContent>
            </Row>
          </div>
          <ToastContainer />
        </Container>
      </section>

      <Modal
        isOpen={modal}
        toggle={customModal}
        size={"lg"}
        centered={true}
        className="bs-modal"
      >
        <ModalHeader toggle={customModal}></ModalHeader>
        <ModalBody toggle={customModal}>
          <p className="title">
            A report with same ID is already in the system – Report ID
            HDFC_worli_12234. Do you wish to replace the Report?
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            onClick={validateBanner}
            className="bs-btn typ-replace min-width margin-right"
          >
            replace
          </button>{" "}
          <button
            onClick={customModal}
            className="bs-btn typ-outline min-width"
          >
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    </main>
  );
}

export default CreateBranch;
